export default {
  'whyus.eyebrow': 'Vì sao chọn chúng tôi',
  'whyus.heroTitleA': 'Vì sao du khách chọn',
  'whyus.home': 'Trang chủ',
  'whyus.whyUs': 'Vì sao chọn chúng tôi',
  'whyus.commitmentsNote': 'Đây không phải lời quảng cáo. Chúng là những tiêu chuẩn vận hành mà chúng tôi tự đặt ra cho mình — và bạn có thể yêu cầu chúng tôi chịu trách nhiệm về chúng.',
  'whyus.companyInfo': 'Thông tin công ty',
  'whyus.name': 'Tên',
  'whyus.license': 'Giấy phép',
  'whyus.address': 'Địa chỉ',
  'whyus.phone': 'Điện thoại',
  'whyus.email': 'Email',
  'whyus.ourOffices': 'Văn phòng của chúng tôi',
  'whyus.ourCoverage': 'Phạm vi hoạt động',
  'whyus.travelersFrom': 'Du khách đến từ',
  'whyus.accountName': 'Tên tài khoản:',
  'whyus.bank': 'Ngân hàng:',
  'whyus.account': 'Số tài khoản:',
  'whyus.swift': 'SWIFT:',
  'whyus.videoTestimonial': 'Video đánh giá',
  'whyus.clickToClose': 'Nhấp để đóng',
  'whyus.heroAlt': 'Vì sao chọn Vietnam Travel',
  'whyus.finalCtaAlt': 'Phong cảnh Việt Nam',
  'whyus.mapTitle': 'Bản đồ Việt Nam',
};